<div id="collapseOne" class="accordion-collapse collapse show" aria-labelledby="headingOne"
  data-bs-parent="#accordionExample">
  <div class="accordion-body">
    <div class="question-part">
      <form *ngIf="formLoaded" [formGroup]="controlAssessmentForm">
        <div class="notificationDiv" *ngIf="isCompleted" [ngClass]="isArabic ? 'arabicAlign' : ''">
          <p class="notificationTxt" [ngClass]="isArabic ? 'arabicNotification' : ''">
            <ng-container *ngIf="!isView">
              <span *ngIf="!isArabic">You have answered all questions here. You can review or update your answers any
                time before submission. <span
                  [class.d-none]="isCompleted && isLastSection && isLastCategory && isLastSubcategory">Please click
                  'Next' to
                  continue.</span></span>
              <span *ngIf="isArabic">
                <span>لقد أجبت عن جميع الأسئلة هنا. يمكنك مراجعة إجاباتك أو تعديلها في أي وقت قبل إرسال التقييم.</span>
                <span [class.d-none]="isCompleted && isLastSection && isLastCategory && isLastSubcategory"> يرجى النقر
                  على "التالي" للمتابعة. </span>
                <!-- <span *ngIf="isArabic">لقد قمت بتصفح جميع الأسئلة هنا. يمكنك إعادة تصفح الأسئلة في أي وقت لمراجعتها أو
                تحديثها قبل إرسالها. الرجاء النقر على "التالي" للمتابعة</span> -->
              </span>
            </ng-container>
            <ng-container *ngIf="isView">
              <span [class.d-none]="isCompleted && isLastSection && isLastCategory && isLastSubcategory">
                <span *ngIf="!isArabic">You have visited all questions for this section. Please click on 'Next' to
                  continue with other sections.</span>
                <span *ngIf="isArabic">لقد قمت بزيارة جميع الأسئلة لهذا القسم. الرجاء النقر فوق "التالي" لمتابعة الأقسام
                  الأخرى</span>
              </span>
              <span *ngIf="isCompleted && isLastSection && isLastCategory && isLastSubcategory">
                <span *ngIf="!isArabic">You have visited all questions for this assessment.</span>
                <span *ngIf="isArabic">لقد قمت بزيارة جميع الأسئلة لهذا التقييم.</span>
              </span>
            </ng-container>
          </p>
          <div class="quesBtnDiv" [ngClass]="isArabic ? 'arabicAlignBtn' : ''">
            <button type="submit" class="btn btn-primary mb-3 quesBackBtn" (click)="goToInitialQuestion()">
              <span *ngIf="!isArabic">BACK</span>
              <span *ngIf="isArabic">العودة</span>
            </button>
            <button [class.d-none]="isCompleted && isLastSection && isLastCategory && isLastSubcategory" type="submit"
              class="btn btn-primary mb-3 quesNxtBtn" (click)="goToNextSubcategory()">
              <span *ngIf="!isArabic">Next</span>
              <span *ngIf="isArabic">التالي</span>
            </button>
          </div>
        </div>

        <ng-container *ngIf="isResubmit && allQuestions[0]?.fields?.length==0">
          <div [ngClass]="isArabic ? 'arabicAlign' : ''">
            <span *ngIf="isArabic" class="errNoQues">لا يوجد سؤال مرفوض</span>
            <span *ngIf="!isArabic" class="errNoQues">No rejected question available</span>
          </div>
        </ng-container>

        <ng-container *ngFor="let ques of allQuestions[0].fields; let idx = index">
          <ng-container *ngIf="selectedQues === idx && (ques?.isHidden == undefined || ques?.isHidden == false)">
            <div class="ques mb-3" [ngClass]="isArabic ? 'arabicAlign' : ''">
              <span class="round" [ngClass]="isArabic ? 'arabicAlign' : ''">
                <span *ngIf="isArabic">س</span>
                <span *ngIf="!isArabic">Q</span>
                <span>{{idx+1}}</span>
              </span>
              <div class="quesRight">
                <div>
                  <pre class="ques-text" *ngIf="!isArabic || (isArabic && !ques.labelArabic)">{{ques.label}}</pre>
                  <pre class="ques-text" *ngIf="isArabic && ques.labelArabic">{{ques.labelArabic}}</pre>
                </div>
              </div>
            </div>

            <ng-container *ngFor="let eachControl of ques.controls; let controlIdx = index">
              <div class="labelSection">
                <label class="mt-4 ques quesLabel" [ngClass]="isArabic ? 'rightAlign' : ''"><span
                    *ngIf="!isArabic">{{eachControl.label}}</span>
                  <span *ngIf="isArabic">{{eachControl.arabicLabel}}</span></label>
                <div class="tooltipDiv" [ngClass]="isArabic ? 'arabicTooltipAlign' : ''">
                  <div class="tooltipMsg">
                    <span *ngIf="!isArabic">Please click the icon for more information</span>
                    <span *ngIf="isArabic">يرجى النقر على الأيقونة لمزيد من المعلومات</span>
                  </div>
                  <!-- <div class="tooltipIcon" 
                      [tooltip]="isArabic ? eachControl.tooltipDataArabic : eachControl.tooltipData" id="tooltipIcon"
                      placement="left" triggers="click"
                      [ngClass]="isArabic ? 'arabicTooltipIcon' : ''" *ngIf="!isArabic">i</div>
                      <div class="tooltipIcon" 
                      [tooltip]="isArabic ? eachControl.tooltipDataArabic : eachControl.tooltipData" id="tooltipIcon"
                      placement="right" triggers="click"
                      [ngClass]="isArabic ? 'arabicTooltipIcon' : ''" *ngIf="isArabic">i</div> -->
                  <div class="tooltipIcon" #tooltipTrigger="bs-tooltip"
                    [tooltip]="isArabic ? eachControl.tooltipDataArabic : eachControl.tooltipData" id="tooltipIcon"
                    placement="left" triggers="click" [ngClass]="isArabic ? 'arabicTooltipIcon' : ''" *ngIf="!isArabic">
                    i</div>

                  <div class="tooltipIcon" #tooltipTrigger="bs-tooltip"
                    [tooltip]="isArabic ? eachControl.tooltipDataArabic : eachControl.tooltipData" id="tooltipIcon"
                    placement="right" triggers="click" [ngClass]="isArabic ? 'arabicTooltipIcon' : ''" *ngIf="isArabic">
                    i</div>
                </div>
              </div>

              <div class="ans-pnl">
                <div class="inner1">
                  <div class="" [ngClass]="'col-'+eachControl.columnSizeLg">
                    <app-question [question]="ques" [eachControl]="eachControl" [controlIndex]="controlIdx"
                      [form]="controlAssessmentForm" [assessmentType]="'mainAssessment'"
                      [isSubmittedEvent]="saveNextSubject.asObservable()"
                      (inputChanged)="valueChanged($event)"></app-question>

                  </div>
                </div>
              </div>
            </ng-container>
            <!-- <ng-container>
             <button type="submit" class="btn-lg btn-primary ratButton action-item-download download-btn"
                [ngClass]="isArabic ? 'float-start' : 'float-end'" (click)="download()">
                <ng-container>
                    <span *ngIf="!isArabic">DOWNLOAD</span>
                    <span *ngIf="isArabic">تحميل</span>
                </ng-container>
            </button>
            </ng-container> -->
            <!-- <div class="mt-2" [ngClass]="isArabic ? 'f-lt' : 'f-rt'">
              <span *ngIf="ques.crmFiles && ques.crmFiles.length > 0">
                <span *ngIf="!isArabic">Required Documents</span>
                <span *ngIf="isArabic">الملفات المطلوبة</span>
              </span>
              <ul *ngIf="ques.crmFiles && ques.crmFiles.length > 0" class="file-list">
                <li *ngFor="let file of ques.crmFiles; let i = index" class="file-list-item">
                  {{i+1}}. {{ file.filename }}

                  <img src="../../../assets/images/arrow-down.png" class="editIcon download-btn" alt="Edit file"
                    (click)="download(file.annotationid)" />


                </li>
              </ul>
            </div> -->
            <br>
            <ng-container>
              <div class="flex-row-container" [ngClass]="isArabic ? 'pull-right' : 'pull-left'">

                <div class="notes mt-3 notesNew" [ngClass]="isArabic ? 'arabicAlign' : ''">
                  <div class="fileinput" *ngIf="isView ? ques.files && ques.files.length > 0 : true">
                    <!-- Main multiple file input for adding new files -->
                    <input type="file" #mainFileInput multiple (change)="handleFileInput($event, 'notes_' + idx)"
                      [attr.name]="'notesName_' + idx" class="file-input" /> <br>
                    <span *ngIf="isProcessingFiles">processing...</span>
                  </div>

                </div>

                <div class="mt-2" style="flex: 1; min-width: 200px;">
                  <details [ngClass]="isArabic ? 'pull-right' : 'pull-left'"
                    [attr.open]="ques.showDocuments ? '' : null" (toggle)="onDocumentsToggle($event, ques)">
                    <summary>
                      <ng-container *ngIf="!isArabic">Attached Documents</ng-container>
                      <ng-container *ngIf="isArabic">المستندات المرفقة</ng-container>
                    </summary>
                    <ng-container>
                      <div *ngIf="ques.showDocuments" class="document-list mt-2 ms-4">
                        <ng-container *ngIf="ques?.files?.length===0">
                          <p class="text-muted fst-italic">No documents attached.</p>
                        </ng-container>
                        <!-- Files list -->
                        <ul *ngIf="ques.files && ques.files.length > 0" class="file-list">
                          <li *ngFor="let file of ques.files; let i = index" class="file-list-item file-list-row">
                            <span class="file-index">{{ i + 1 }}.</span>
                            <span class="file-name">{{ file.filename }}</span>

                            <span class="file-actions">
                              <img src="../../../assets/images/edit.png" class="icon-doc" alt="Edit file"
                                (click)="triggerFileInputForIndex(i)" *ngIf="canShowEditDeleteIcons(file)" />

                              <img src="../../../assets/images/delete.png" class="icon-doc deleteIcon" alt="Delete file"
                                *ngIf="canShowEditDeleteIcons(file)" (click)="deleteFile(i, ques)" />
                              <img src="../../../assets/images/arrow-down.png" class="editIcon download-btn"
                                alt="Download" (click)="download(file.annotationid)" *ngIf="isResubmit" />
                            </span>
                          </li>
                        </ul>
                      </div>
                    </ng-container>
                  </details>
                </div>
                <div class="divider" *ngIf="ques.showCrmDocuments"></div>

                <div class="mt-2" style="flex: 1; min-width: 200px;" *ngIf="ques.crmFiles && ques.crmFiles.length > 0">
                  <details [ngClass]="isArabic ? 'pull-right' : 'pull-left'"
                    [attr.open]="ques.showCrmDocuments ? '' : null" (toggle)="onCrmDocumentsToggle($event, ques)">
                    <summary>
                      <ng-container *ngIf="!isArabic">Required Documents</ng-container>
                      <ng-container *ngIf="isArabic">الملفات المطلوبة</ng-container>
                    </summary>
                    <ng-container>
                      <div *ngIf="ques.showCrmDocuments" class="document-list mt-2 ms-4">
                        <ul *ngIf="ques.crmFiles && ques.crmFiles.length > 0" class="file-list">
                          <li *ngFor="let file of ques.crmFiles; let i = index" class="file-list-item file-list-row">
                            <span class="file-index">{{ i + 1 }}.</span>
                            <span class="file-name">{{ file.filename }}</span>

                            <span class="file-actions">
                              <img src="../../../assets/images/arrow-down.png" class="editIcon download-btn"
                                alt="Download" (click)="download(file.annotationid)" />
                            </span>
                          </li>
                        </ul>

                      </div>
                    </ng-container>
                  </details>
                </div>
                <!-- Validation messages -->
                <span *ngIf="ques.notesRequired && submitted && (!ques.files || ques.files.length === 0)"
                  class="sizeErr" [ngClass]="isArabic ? 'arabicRightAlign' : ''">
                  <span *ngIf="!isArabic">Please select at least one file.</span>
                  <span dir="rtl" lang="ar" *ngIf="isArabic">يرجى اختيار ملف واحد على الأقل</span>
                </span>

                <span *ngIf="fileTypeErr" class="sizeErr" [ngClass]="isArabic ? 'arabicRightAlign' : ''">
                  <span *ngIf="!isArabic">Please select files having extensions .JPEG/.pdf only.</span>
                  <span dir="rtl" lang="ar" *ngIf="isArabic">يرجى اختيار ملفات بصيغة .JPEG أو .pdf فقط.</span>
                </span>

                <span *ngIf="showSizeErr" class="sizeErr" [ngClass]="isArabic ? 'arabicRightAlign' : ''">
                  <span *ngIf="!isArabic">File size exceeded 20mb</span>
                  <span dir="rtl" lang="ar" *ngIf="isArabic">حجم الملف يتجاوز 20 ميغابايت</span>
                </span>

                <span *ngIf="fileUploadErr" class="sizeErr" [ngClass]="isArabic ? 'arabicRightAlign' : ''">
                  <span *ngIf="!isArabic">File has not been uploaded</span>
                  <span dir="rtl" lang="ar" *ngIf="isArabic">لم يتم تحميل الملف</span>
                </span>
              </div>
              <div class="notes mt-3" [ngClass]="isArabic ? 'arabicAlign' : ''" *ngIf="!isView">
                <label *ngIf="!isArabic" class="noteclass">Notes:</label>
                <label *ngIf="isArabic">: ملاحظة</label>
              </div>

              <div class="noteGuidance" [ngClass]="isArabic ? 'rightAlign' : ''">

                <!-- <span *ngIf="!isView && isArabic && !isResubmit && !isChecker">* يمكنك تحديد ملف واحد بحد أقصى بحد أقصى 5 ميغا بايت. سيتم تحميل الملف بمجرد النقر فوق "حفظ والتالي".</span> -->
                <span dir="rtl" lang="ar" *ngIf="!isView && isArabic && !isResubmit && !isChecker">لتصفح المرفق، يرجى النقر على "اختيار
                  ملف"
                  ثم النقر على زر "حفظ والتالي" لتحميله
                  *</span>
                <!-- <span *ngIf="!isView && !isArabic && !isResubmit && !isChecker">* You can select a maximum of 1 file with a maximum size of 5mb. The file will be uploaded once you click "Save & Next".</span> -->
                <span *ngIf="!isView && !isArabic && !isResubmit && !isChecker">* To browse an attachment, please
                  click
                  on 'Choose File' and then click on 'SAVE & NEXT' button to upload it.</span>


                <!-- <span *ngIf="!isView && !isArabic && isResubmit">* You can select a maximum of 1 file with a maximum size of 5mb. The file will be uploaded once you click "Resubmit".</span> -->
                <span *ngIf="!isView && !isArabic && isResubmit">* To browse an attachment, please click on <b>'Choose
                    File'</b> and then click on <b>'Resubmit'</b> button to upload it.</span>
                <!-- <span *ngIf="!isView && isArabic && isResubmit">* يمكنك تحديد ملف واحد بحد أقصى بحد أقصى 5 ميغا بايت. سيتم تحميل الملف بمجرد النقر فوق "إعادة الإرسال".</span> -->
                <span dir="rtl" lang="ar" *ngIf="!isView && isArabic && isResubmit">ثم النقر فوق الزر "إعادة الإرسال" لتحميله "Choose
                  File"
                  لتصفح أحد المرفقات ، يرجى النقر فوق*</span>

                <!-- <span *ngIf="!isView && !isArabic && isChecker && !isResubmit">* You can select a maximum of 1 file with a maximum size of 5mb. The file will be uploaded once you click "Reject"/"Approve".</span> -->
                <span *ngIf="!isView && !isArabic && isChecker && !isResubmit">* To browse an attachment, please click
                  on 'Choose Files' and then click on 'Reject'/'Approve' button to upload it.</span>
                <!-- <span *ngIf="!isView && isArabic && isChecker && !isResubmit">* يمكنك تحديد ملف واحد بحد أقصى بحد أقصى 5 ميغا بايت. سيتم تحميل الملف بمجرد النقر فوق "رفض" / "موافقة".</span> -->
                <span dir="rtl" lang="ar" *ngIf="!isView && isArabic && isChecker && !isResubmit" dir="rtl" lang="ar">ثم النقر فوق الزر 'رفض'/'يوافق' لتحميله
                  "Choose Files" لتصفح أحد المرفقات ، يرجى النقر فوق*</span>
              </div>
              <div class="noteGuidance" [ngClass]="isArabic ? 'rightAlign' : ''">

                <span *ngIf="!isView && !isArabic">* You can upload up to 10 files in .JPEG or .PDF format, with a
                  combined maximum size of 20 MB. </span>
                <span *ngIf="!isView && isArabic" dir="rtl" lang="ar">
                  * يمكنك تحميل ما يصل إلى 10 ملفات بصيغة JPEG. أو PDF. على ألا يتجاوز الحجم الإجمالي لجميع الملفات
                  20 ميجابايت.
                </span>
              </div>
            </ng-container>
            <!-- <ng-container *ngIf="!isView && isChecker && !isResubmit"> -->
            <!-- <ng-container *ngIf="(isView && ques?.commentHistory?.length > 0) || (isChecker && !isView) || isResubmit"> -->
            <ng-container>
              <div class="notes comments mt-4" [ngClass]="isArabic ? 'rightAlign' : ''">
                <label *ngIf="!isArabic" class="mb-1">Comment History: </label>
                <label *ngIf="isArabic" class="mb-1" dir="rtl" lang="ar"> سجل التعليقات : </label>
                <ng-container *ngIf="ques?.commentHistory?.length>0">
                  <!-- <ng-container *ngFor="let commentHistory of ques?.commentHistory"> -->
                  <pre class="comments-history">{{sortCommentsByDateDesc(ques?.commentHistory)}}</pre>
                  <!-- </ng-container> -->
                </ng-container>
                <label *ngIf="!isArabic" class="mt-3">Comments: </label>
                <label *ngIf="isArabic" class="mt-3">: التعليقات</label>
                <textarea class="form-control comment mt-1" [placeholder]="!isArabic ? 'Enter here' : 'أدخل هنا'"
                  [id]="'comments_'+idx" name="'commentsName_'+idx" (change)="commentsChange($event)"
                  (keydown)="commentEnter();" [value]="(ques?.comments == 'undefined' || ques?.comments == undefined || ques?.comments == 'null' 
                || ques?.comments == null) ? '' : ques?.comments" [ngClass]="isArabic ? 'rightAlign' : ''"
                  [disabled]="isView"></textarea>
                <div class="mt-1" *ngIf="showCommentErr || showAlphanumericCommentErr || showNumericCommentErr"
                  [ngClass]="isArabic ? 'rightAlign' : ''">
                  <ng-container *ngIf="showCommentErr">
                    <!-- ques?.commentHistory?.length>0 -->
                    <span *ngIf="!isArabic" class="sizeErr">Comments is required</span>
                    <span *ngIf="isArabic" class="sizeErr">التعليقات مطلوبة</span>
                  </ng-container>
                  <ng-container *ngIf="showAlphanumericCommentErr || showNumericCommentErr">
                    <ng-container *ngIf="showNumericCommentErr">
                      <span *ngIf="!isArabic" class="sizeErr">Only numbers are allowed</span>
                      <span *ngIf="isArabic" class="sizeErr">يسمح فقط بالأرقام</span>
                    </ng-container>
                    <ng-container *ngIf="showAlphanumericCommentErr">
                      <span *ngIf="!isArabic" class="sizeErr">Only letters or numbers are allowed</span>
                      <span *ngIf="isArabic" class="sizeErr">يسمح فقط باستخدام الأحرف أو الأرقام</span>
                    </ng-container>
                  </ng-container>

                </div>
              </div>
            </ng-container>
            <div class="upload-overlay"></div>
            <div id="uploadPopup" class="upload-popup">
              <p *ngIf="!isArabic">Uploading files, please wait...</p>
              <p *ngIf="isArabic">يتم الآن تحميل الملفات، يُرجى الانتظار.</p>
              <progress id="uploadProgressBar" value="0" max="100" style="width: 100%; height: 20px;"></progress>
              <p id="progressPercent" style="text-align: right; margin: 5px 0 0;">0%</p>
            </div>
            <div *ngIf="serverErr" class="errMsg" [ngClass]="isArabic ? 'errMsgRightArabic' : 'errMsgRight'">
              <span>{{serverErr}}</span>
            </div>
            <div class="btn-pnl quesBtns mt-3" [ngClass]="isArabic ? 'arabicAlign' : ''">
              <div class="left-btn">
                <button type="submit" class="btn btn-primary mb-3" (click)="goToPreviousQuestion()" *ngIf="idx !== 0"
                  [disabled]="disableSaveNext">
                  <span *ngIf="!isArabic">BACK</span>
                  <span *ngIf="isArabic">العودة</span>
                </button>
              </div>
              <div class="right-btns" [ngClass]="isArabic ? 'arabicAlign' : ''">
                <button type="submit" class="btn btn-primary mb-3" (click)="goToNextQuestion()" *ngIf="!isView"
                  [disabled]="disableSaveNext">
                  <!-- <button type="submit" class="btn btn-primary mb-3" (click)="goToNextQuestion()"
                  *ngIf="!isView && !isChecker && !isResubmit" [disabled]="disableSaveNext"> -->
                  <span *ngIf="!isArabic">SKIP</span>
                  <span *ngIf="isArabic">تخطي</span>
                </button>
                <button type="submit" class="btn btn-primary mb-3 saveNxtBtn" (click)="goToNextQuestion()"
                  *ngIf="isView">
                  <span *ngIf="!isArabic">NEXT</span>
                  <span *ngIf="isArabic">التالي</span>
                </button>
                <button type="submit" class="btn btn-primary mb-3 saveNxtBtn" (click)="onSubmit()"
                  *ngIf="!isView && !isChecker && !isResubmit" [disabled]="disableSaveNext">
                  <span *ngIf="!isArabic">SAVE & NEXT</span>
                  <span *ngIf="isArabic">حفظ ومتابعة</span>
                </button>
                <button type="submit" class="btn btn-primary mb-3 saveNxtBtn" (click)="onSubmit()"
                  *ngIf="!isView && isResubmit" [disabled]="disableSaveNext">
                  <span *ngIf="!isArabic">Resubmit</span>
                  <span *ngIf="isArabic">إعادة الإرسال</span>
                </button>
                <button type="submit" class="btn btn-primary mb-3" (click)="approveOrRejectQues('reject')"
                  *ngIf="!isView && isChecker && !isResubmit" [disabled]="disableSaveNext">
                  <span *ngIf="!isArabic">REJECT</span>
                  <span *ngIf="isArabic">رفض</span>
                </button>
                <button type="submit" class="btn btn-primary mb-3 saveNxtBtn" (click)="approveOrRejectQues('approve')"
                  *ngIf="!isView && isChecker && !isResubmit" [disabled]="disableSaveNext">
                  <span *ngIf="!isArabic">APPROVE</span>
                  <span *ngIf="isArabic">يوافق</span>
                </button>
              </div>
            </div>

          </ng-container>
        </ng-container>
      </form>
    </div>
  </div>
</div>